import React from "react";
import {
  Container,
  Box,
  AppBar,
  Toolbar,
  Typography,
  Grid,
} from "@mui/material";
import { history } from "../history";
import { actions } from "_model/report";
import { useDispatch, useSelector } from "react-redux";
import IconButton from "@mui/material/IconButton";
// import MenuIcon from '@mui/icons-material/Menu';
import Home from "@mui/icons-material/Home";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";
import LogoHeader from "./LogoHeader";
import "../assets/components/header.scss";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Header = () => {
  const customer = useSelector((state) => state.report.customer);

  useEffect(() => {
    if (customer === undefined) {
      history.push("/login");
    }
  }, [customer]);

  const dispatch = useDispatch();

  const handleLogoutClick = () => {
    const BANNER_KEY = "bannerClosed_v1";

    setTimeout(() => {
      localStorage.removeItem(BANNER_KEY);
      window.dispatchEvent(new Event("bannerReset"));
    }, 1000);

    dispatch(actions.logout());
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    setAnchorEl(null);
    history.push(event.currentTarget.dataset.route);
  };

  const backLink = location.pathname.startsWith("/builddata")
    ? "/dashboard/denunce"
    : location.pathname.startsWith("/build")
    ? "/dashboard/pratiche"
    : location.pathname.startsWith("/dashboard/pratica/consulenza")
    ? "/dashboard/pratiche"
    : "/dashboard";

  return (
    <>
      {/* <div style={{ height: "100px" }} /> */}
      <Grid container className="Header">
        <Grid
          item
          xs={2}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <a
            href={
              location.pathname === "/dashboard/info-service"
                ? undefined
                : backLink
            }
            onClick={(e) => {
              if (location.pathname === "/dashboard/info-service") {
                e.preventDefault();
                window.history.back();
              }
            }}
            style={{
              color: "#fff",
              display: location.pathname === "/dashboard" ? "none" : "flex",
            }}
          >
            <div className="icon-back-dashoard" />
          </a>
        </Grid>
        <Grid
          item
          xs={8}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <LogoHeader></LogoHeader>
        </Grid>
        <Grid
          item
          xs={2}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <IconButton
            className="Profile"
            size="small"
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={handleClick}
          >
            <div className="icon-menu-header" />
          </IconButton>
          <Menu
            marginThreshold={0}
            elevation={0}
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem
              sx={{
                fontFamily: "Quicksand, sans-serif",
                fontWeight: 500,
                color: "#20305b",
              }}
              data-route="/dashboard"
              onClick={handleClose}
            >
              Dashboard
            </MenuItem>
            <MenuItem
              onClick={handleLogoutClick}
              sx={{
                fontFamily: "Quicksand, sans-serif",
                fontWeight: 500,
                color: "#20305b",
              }}
            >
              Esci
            </MenuItem>
          </Menu>
        </Grid>
      </Grid>
    </>
  );
};

export default Header;
